module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mailing-list/component/home-main-modal-region/home-main-modal-region.component.sass
// module id = ./src/app/modules/mailing-list/component/home-main-modal-region/home-main-modal-region.component.sass
// module chunks = main